import { render, staticRenderFns } from "./detail-form.vue?vue&type=template&id=735fca31&"
import script from "./detail-form.vue?vue&type=script&lang=ts&"
export * from "./detail-form.vue?vue&type=script&lang=ts&"
import style0 from "./detail-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports